// extracted by mini-css-extract-plugin
export var categoryTitle = "MegaMenu-module--categoryTitle--433b6";
export var isReverse = "MegaMenu-module--isReverse--1cfba";
export var location = "MegaMenu-module--location--37eb4";
export var locationBody = "MegaMenu-module--locationBody--2d2d4";
export var locationDesc = "MegaMenu-module--locationDesc--e40e2";
export var locationImg = "MegaMenu-module--locationImg--766b7";
export var locationTitle = "MegaMenu-module--locationTitle--a5040";